<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.requestDeliveries'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('deliveryRequisition.serialNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.orderSerialNo"
            :placeholder="$t('order.serialNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.applyName"
            :placeholder="$t('deliveryRequisition.applyName')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.customerName"
            :placeholder="$t('menu.customers')"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            v-model="searchForm"
            type="datetime"
            field="createAt"
            :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            v-model="searchForm"
            type="datetime"
            field="handOverAt"
            :start-placeholder="$t('rules.startAt', [$t('delivery.deliverAt')])"
            :end-placeholder="$t('rules.endAt', [$t('delivery.deliverAt')])"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="recordsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        :expand-config="{
          accordion: true,
          lazy: true,
          loadMethod: loadContentMethod,
        }"
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        >
        <vxe-table-column type="expand" width="30px">
          <template v-slot:content="{ row }">
            <vxe-table
              :data="row.detailList"
              :merge-cells="mergeCells"
              id="bargainsTable"
              row-id="id"
              ref="recordsTable"
              class="recordsTable"
              :row-class-name="calculateBgColor"
              size="mini"
              resizable
              round
              auto-resize
              highlight-hover-row
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="images"
                :title="$t('product.images')"
                width="80"
              >
                <template v-slot="{ row }">
                  <span v-if="!row.isBargain">
                    <thumbnail :images="row.images"></thumbnail>
                  </span>
                  <div v-else>
                    <span class="float-left">
                      <span class="mgr5">{{ row.serialNo }}</span>
                      <span class="font10 mgr5"
                        >{{ $t("bargain.productQty") }}:{{
                          row.productQty
                        }}</span
                      >
                      <span
                        v-if="Permit.canActions('globalSalePrice')"
                        class="font10"
                      >
                        <span class="mgr5">
                          {{ $t("bargain.amount") }}:
                          <currency :code="row.currency"></currency>
                          {{ row.amount }}
                        </span>
                        <span v-if="row.settleType == 'later'">{{
                          $t("settleTypes.later")
                        }}</span>
                        <span v-if="row.settleType == 'now'">
                          <span class="mgr5">
                            {{ $t("bargain.receive") }}:
                            <currency :code="row.currency"></currency>
                            {{ row.payAmount }}
                          </span>
                          <span v-if="row.ignoreAmount > 0" class="mgr5">
                            {{ $t("bargain.ignore") }}:
                            <currency :code="row.currency"></currency>
                            {{ row.ignoreAmount }}
                          </span>
                          <span v-if="row.differAmount > 0" class="red mgr5">
                            {{ $t("bargain.differ") }}:
                            <currency :code="row.currency"></currency>
                            {{ row.differAmount }}
                          </span>
                          <span
                            v-if="row.differAmount == 0"
                            class="green mgr5"
                            >{{ $t("bargain.settled") }}</span
                          >
                          <span v-if="row.differAmount < 0" class="orange">
                            {{ $t("bargain.leave") }}:
                            <currency :code="row.currency"></currency>
                            {{ row.differAmount * -1 }}
                          </span>
                        </span>
                      </span>
                    </span>
                    <div
                      v-if="row.financeAudit != null"
                      class="font12 float-left"
                    >
                      <el-popover placement="right" width="300" trigger="click">
                        <div>
                          <div class="lineH24">
                            {{ $t("verify.commentName") }}:
                            {{ row.financeAudit.commentName }}
                          </div>
                          <div class="lineH24">
                            {{ $t("verify.commentAt") }}:
                            {{ row.financeAudit.commentAt }}
                          </div>

                          <div
                            v-if="row.financeAudit.dealType == 'reject'"
                            class="lineH24"
                          >
                            {{ $t("verify.comment") }}:
                            {{ row.financeAudit.comment }}
                          </div>
                        </div>
                        <span
                          slot="reference"
                          class="popover-reference"
                          :class="
                            row.financeAudit.dealType == 'agree'
                              ? 'green-shallow'
                              : 'red'
                          "
                          >{{ $t("action.verify") }}({{
                            $t(
                              "verifyTypesSimple." + row.financeAudit.dealType
                            )
                          }})</span
                        >
                      </el-popover>
                    </div>

                    <span class="float-right font10">
                      {{ $t("menu.customers") }}:
                      <span
                        v-if="
                          row.replaceCustomerId != null && row.customer != null
                        "
                        >{{ row.customer.name }}</span
                      >
                      <span v-if="row.replaceCustomerId == null">{{
                        row.customerName
                      }}</span>
                      <span
                        v-if="row.customer != null && row.customer.type != null"
                        >({{ $t("customerTypes." + row.customer.type) }})</span
                      >
                      {{ $t("text.owner") }}:{{ row.ownerName }}
                      {{ row.shopName }}
                    </span>
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="serialNo"
                :title="$t('text.serialNo')"
                min-width="120"
              >
                <template v-slot="{ row }">
                  <small v-if="row.hurry" class="red"
                    >({{ $t("order.hurrySimple") }})</small
                  >
                  <span class="font10">
                    <s v-if="row.workflowState == 'canceled'" class="grey">{{
                      row.serialNo
                    }}</s>
                    <span v-else>{{ row.serialNo }}</span>
                  </span>
                  <div class="font10">{{ row.innerSerialNo }}</div>
                  <div>
                    <state-label
                      :state="row.workflowState"
                      :permit="Permit.canActions('orderDealView')"
                    >
                      <span v-if="Permit.canActions('orderDealView')">{{
                        $t("orderStates." + row.workflowState)
                      }}</span>
                      <span v-else>{{
                        $t("orderStatesNoPermit." + row.workflowState)
                      }}</span>
                    </state-label>
                    <span v-if="row.dealType !== null">
                      {{ $t("dealTypes." + row.dealType) }}
                    </span>
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="handOverAt"
                :title="$t('text.handOverAt')"
                min-width="120"
              >
                <template v-slot="{ row }">
                  {{ row.handOverAt }}
                  <div v-if="row.confirmAt != null" class="font10 green">
                    {{ $t("order.confirm") }}:{{ row.confirmAt }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="productNo"
                :title="$t('product.productNo')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.productNo }}
                  <small
                    v-if="
                      row.customerProductNo != null &&
                      row.customerProductNo != ''
                    "
                    >({{ row.customerProductNo }})</small
                  >

                  <div class="font10">
                    {{ row.categoryName }}
                    <span v-if="row.productBrand != null">/</span>
                    {{ row.productBrand }}
                  </div>
                  <div class="font10">{{ row.color }} {{ row.size }}</div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                v-if="Permit.canActions('globalSalePrice')"
                field="price"
                :title="$t('order.price')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  <currency :code="row.currency"></currency>
                  {{ row.price }}
                  <small
                    v-if="row.discountRate != null && row.discountRate != 0"
                    >({{ row.discountRate }}%)</small
                  >
                  <div
                    v-if="row.extraCharge != null && row.extraCharge != 0"
                    class="font10"
                  >
                    {{ $t("order.extraChargeSimple") }}:
                    <currency :code="row.currency"></currency>
                    {{ row.extraCharge }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="quantity"
                :title="$t('text.quantity')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  {{ row.quantity }}{{ row.unit || "" }}
                  <div class="font10">
                    {{ $t("order.complete") }}:{{ row.dealQuantity
                    }}{{ row.unit || "" }}
                    <small v-if="row.orderReceives != null">
                      ({{ row.orderReceives.map((r) => r.shopName).join(",") }})
                    </small>
                  </div>
                  <!-- <el-popover placement="right" width="400" trigger="click">
                    <vxe-table
                      v-if="row.orderReceives != null"
                      :data="row.orderReceives"
                      id="orderReceivesTable"
                      ref="orderReceivesTable"
                      class="recordsTable"
                      size="mini"
                      resizable
                      round
                      auto-resize
                      highlight-hover-row
                      :scroll-y="{ enabled: false }"
                    >
                      <vxe-table-column
                        field="shopName"
                        :title="$t('order.receiveShopName')"
                      />
                      <vxe-table-column
                        field="quantity"
                        :title="$t('text.quantity')"
                      />
                      <vxe-table-column
                        field="createAt"
                        :title="$t('text.date')"
                        width="110px"
                      />
                    </vxe-table>
                    <div slot="reference" class="popover-reference font10">
                      {{ $t("order.complete") }}:{{ row.dealQuantity
                      }}{{ row.unit || "" }}
                    </div>
                  </el-popover> -->
                  <div class="font10">
                    <el-popover
                      placement="right"
                      width="600"
                      trigger="click"
                      @show="getDeliveries(row)"
                    >
                      <vxe-table
                        :data="deliveries"
                        id="deliverInfosTable"
                        row-id="id"
                        ref="deliverInfosTable"
                        class="recordsTable"
                        size="mini"
                        resizable
                        round
                        auto-resize
                        highlight-hover-row
                        :scroll-y="{ enabled: false }"
                      >
                        <vxe-table-column
                          field="deliverType"
                          :title="$t('delivery.deliveryMethode')"
                        >
                          <template v-slot="{ row }">
                            <span v-if="row.deliverType != null">{{
                              $t("deliverTypes." + row.deliverType)
                            }}</span>
                          </template>
                        </vxe-table-column>
                        <vxe-table-column
                          field="express"
                          :title="$t('delivery.express')"
                        />
                        <vxe-table-column
                          field="deliverMethodName"
                          :title="$t('delivery.channel')"
                        />
                        <vxe-table-column
                          field="tracking"
                          :title="$t('delivery.tracking')"
                        />
                        <vxe-table-column
                          field="attachment"
                          :title="$t('product.attachment')"
                        >
                          <template v-slot="{ row }">
                            <thumbnail-text
                              :srcs="row.attachment"
                              :text="'附件'"
                            />
                          </template>
                        </vxe-table-column>
                        <vxe-table-column
                          field="deliverBy"
                          :title="$t('delivery.deliverBy')"
                        />
                        <vxe-table-column
                          field="deliverAt"
                          :title="$t('delivery.deliverAt')"
                        />
                      </vxe-table>
                      <span slot="reference" class="popover-reference">
                        {{ $t("order.delivered") }}:{{ row.deliveredQuantity
                        }}{{ row.unit || "" }}
                      </span>
                    </el-popover>
                  </div>

                  <div
                    v-if="row.deliveryRequisitionQuantity > 0"
                    class="font10"
                  >
                    <el-popover
                      placement="right"
                      width="600"
                      trigger="click"
                      @show="getDeliveryRequisitions(row)"
                    >
                      <vxe-table
                        :data="deliveryRequisitionInfos"
                        id="deliveryRequisitionInfosTable"
                        row-id="id"
                        ref="deliveryRequisitionInfosTable"
                        class="recordsTable"
                        size="mini"
                        resizable
                        round
                        auto-resize
                        highlight-hover-row
                        :scroll-y="{ enabled: false }"
                      >
                        <vxe-table-column
                          field="serialNo"
                          :title="$t('deliveryRequisition.serialNo')"
                        />

                        <vxe-table-column
                          field="applyName"
                          :title="$t('deliveryRequisition.applyName')"
                        />
                        <vxe-table-column
                          field="quantity"
                          :title="$t('deliveryRequisition.quantity')"
                        >
                          <template v-slot="{ row }">
                            <span
                              v-if="
                                row.deliveryRequisitionItems &&
                                row.deliveryRequisitionItems.length != 0
                              "
                            >
                              {{ row.deliveryRequisitionItems[0].quantity }}
                              <raw-html-limit-number
                                :content="
                                  row.deliveryRequisitionItems[0].remark
                                "
                                :number="10"
                              />
                            </span>
                          </template>
                        </vxe-table-column>
                        <vxe-table-column
                          field="handOverAt"
                          :title="$t('deliveryRequisition.handOverAt')"
                        />
                        <vxe-table-column
                          field="remark"
                          :title="$t('text.remark')"
                        >
                          <template v-slot="{ row }">
                            <raw-html-limit-number
                              :content="row.remark"
                              :number="10"
                            />
                            <div>
                              <attribute :content="row.specJson" :number="8" />
                            </div>
                          </template>
                        </vxe-table-column>
                        <vxe-table-column
                          field="createAt"
                          :title="$t('delivery.createAt')"
                        />
                      </vxe-table>
                      <span slot="reference" class="popover-reference">
                        {{ $t("order.delivered") }}:{{ row.deliveredQuantity
                        }}{{ row.unit || "" }}
                      </span>
                    </el-popover>
                  </div>
                </template>
              </vxe-table-column>

              <vxe-table-column
                field="deliverQuantity"
                :title="$t('deliveryRequisition.quantity')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  <span v-if="getDeliveryRequisitionItem(row) != null">
                    {{ getDeliveryRequisitionItem(row).quantity }}
                    <div>
                      <raw-html-limit-number
                        :content="getDeliveryRequisitionItem(row).remark"
                        :number="10"
                      />
                    </div>
                  </span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="createAt"
                :title="$t('text.createAt')"
                min-width="110"
              />
              <vxe-table-column
                field="remark"
                :title="$t('text.remark')"
                min-width="60"
              >
                <template v-slot="{ row }">
                  <raw-html-limit-number
                    :content="row.remark"
                    :number="10"
                    type="richText"
                  />
                </template>
              </vxe-table-column>
            </vxe-table>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('deliveryRequisition.serialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <span class="blue" @click="showRow(row)">{{ row.serialNo }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="customerName"
          :title="$t('menu.customers')"
          min-width="100"
        />
        <vxe-table-column
          field="applyName"
          :title="$t('deliveryRequisition.applyName')"
          min-width="100"
        />
        <vxe-table-column
          field="handOverAt"
          :title="$t('deliveryRequisition.handOverAt')"
          min-width="100"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.remark" :number="16" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="110"
        />

        <vxe-table-column
          field="name"
          :title="$t('delivery.deliverInfo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span v-if="row.deliveryRequisitionAudit != null">
              {{ $t("verifyTypes." + row.deliveryRequisitionAudit.dealType) }}
              <div
                v-if="row.deliveryRequisitionAudit.dealType == 'reject'"
                class="font10"
              >
                <raw-html-limit-number
                  :content="row.deliveryRequisitionAudit.comment"
                  :number="10"
                />
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="commentName"
          :title="$t('order.operatorName')"
          min-width="50"
        >
          <template v-slot="{ row }">
            <span v-if="row.deliveryRequisitionAudit != null">{{
              row.deliveryRequisitionAudit.commentName
            }}</span>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="country"
          :title="$t('order.dealAt')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span v-if="row.deliveryRequisitionAudit != null">{{
              row.deliveryRequisitionAudit.commentAt
            }}</span>
          </template>
        </vxe-table-column>

        <vxe-table-column
          v-if="
            !Permit.isFreeEdition() &&
            Permit.canActionsChargeEdition('deliveryRequisitionDelivery')
          "
          field="action"
          :title="$t('text.action')"
          width="110"
        >
          <template v-slot="{ row }">
            <div v-if="row.deliveryRequisitionAudit == null">
              <el-dropdown
                class="mgr10"
                v-if="Permit.extendModels().includes('lmsO')"
              >
                <a class="el-dropdown-link small-link">
                  {{ $t("action.deliver") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div class="font10" @click="deliver(row, 'carry')">
                      {{ $t("deliverTypes.carry") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div class="font10" @click="deliver(row, 'take')">
                      {{ $t("deliverTypes.take") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div class="font10" @click="deliver(row, 'signDeliver')">
                      {{ $t("deliverTypes.signDeliver") }}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button type="text" size="mini" @click="reject(row)">{{
                $t("verifyTypes.reject")
              }}</el-button>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>

    <el-dialog
      :title="$t('verifyTypes.reject')"
      :close-on-click-modal="false"
      :visible.sync="rejectDF"
      width="30%"
    >
      <el-form ref="rejectForm" :model="rejectObj">
        <el-form-item :prop="'comment'">
          <el-input
            size="small"
            v-model.trim="rejectObj.comment"
            type="textarea"
            :placeholder="$t('text.remark')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="rejectDoing"
          size="small"
          @click="rejectSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="rejectDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('deliverTypes.carry')"
      :close-on-click-modal="false"
      :visible.sync="carryDF"
      width="30%"
    >
      <el-form ref="carryForm" :model="carryObj" label-width="80px">
        <el-form-item
          :label="$t('delivery.sender')"
          :prop="'sender'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('delivery.sender')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="carryObj.sender" />
        </el-form-item>
        <el-form-item
          :label="$t('delivery.deliverCost')"
          :prop="'deliverCost'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('delivery.deliverCost')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="carryObj.deliverCost" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="carrySubmitDoing"
          size="small"
          @click="carrySubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="carryDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Util from "@/utils";
import { page, table } from "@/utils/mixins.js";
import DateRange from "@/components/DateRange";
import Currency from "@/components/Currency";

import Show from "./show";
import DeliveryRequisition from "@/api/deliveryRequisition.js";
import Shop from "@/api/shop.js";
import Delivery from "@/api/delivery.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    Show,
    Currency,
  },
  data() {
    return {
      narrows: [
        [
          {
            label: this.$t("order.dealInfo"),
            items: [
              {
                label: this.$t("deliveryRequisitionDealTypes.no"),
                key: "no",
                condition: { deliveryRequisition: "no" },
              },
              {
                label: this.$t("deliveryRequisitionDealTypes.agree"),
                key: "agree",
                condition: { deliveryRequisition: "agree" },
              },
              {
                label: this.$t("action.reject"),
                key: "reject",
                condition: { deliveryRequisition: "reject" },
              },
            ],
          },
        ],
      ],
      initFilter: "no",
      searchForm: {
        serialNo: null,
        customerName: null,
        applyName: null,
        createAtStartAt: null,
        createAtEndAt: null,
        handOverAtStartAt: null,
        handOverAtEndAt: null,
      },
      sorter: {
        sortBy: "deliveryRequisitions_id",
        sortIndicator: "desc",
      },
      //
      currentRowId: null,
      showDF: false,

      // 拒绝
      row: null,
      rejectDF: false,
      rejectObj: {
        comment: null,
      },
      rejectDoing: false,
      //发货
      deliverType: null,
      carryDF: false,
      carryObj: {
        deliverType: null,
        sender: null,
        deliverCost: null,
      },
      carrySubmitDoing: false,
      //
      mergeCells: [],
      deliveries: [],
      //
      shops: [],
      shopsInv: [],
    };
  },
  created() {
    const self = this;
    Shop.findByTenantId().then(function (res) {
      if (res.status === 200) {
        self.shops = res.data;
        self.shopsInv = res.data.filter((s) => s.isInventory === true);
        self.narrows.push([
          {
            label: self.$t("receive.receiveWarehouse"),
            items: self.shopsInv.map((shop) => {
              return {
                label: shop.name,
                key: shop.id.toString() + "apply",
                condition: { receiveShopId: shop.id },
              };
            }),
          },
        ]);
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    // 获取发货信息
    getDeliveries(row) {
      const self = this;
      Delivery.findByOrderUuid(row.uuid).then(function (res) {
        if (res.status == 200) {
          self.deliveries = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getDeliveryRequisitions(row) {
      const self = this;
      DeliveryRequisition.findByOrderSerialNo({
        orderSerialNo: row.serialNo,
        deliveryRequisition: "unDeal",
      }).then(function (res) {
        if (res.status === 200) {
          self.deliveryRequisitionInfos = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //
    getDeliveryRequisitionItem(item) {
      const self = this;
      if (self.row.deliveryRequisitionItems.length !== 0) {
        const currentDeliveryRequisitionItem = self.row.deliveryRequisitionItems.find(
          (d) => d.orderId === item.id
        );
        return currentDeliveryRequisitionItem;
      } else {
        return null;
      }
    },

    loadContentMethod({ row }) {
      const self = this;
      return new Promise((resolve) => {
        DeliveryRequisition.findById(row.id).then(function (res) {
          if (res.data.code === 200) {
            self.row = res.data.entity;
            let deliveryRequisition = res.data.entity;
            if (
              deliveryRequisition.bargains &&
              deliveryRequisition.bargains.length != 0
            ) {
              row.detailList = self.buildTableData(
                deliveryRequisition.bargains
              );
              self.mergeCells = self.buildMergeCells(
                deliveryRequisition.bargains
              );
              resolve();
            } else {
              row.detailList = [];
              resolve();
            }
          } else {
            self.sysError();
          }
        });
      });
    },
    buildTableData(records) {
      let rs = [];
      records.forEach((record) => {
        let bOrder = {
          isBargain: true,
          id: record.id,
          uuid: record.uuid,
          serialNo: record.serialNo,
          shopId: record.shopId,
          shopName: record.shopName,
          settleType: record.settleType,
          amount: record.amount,
          currency: record.currency,
          customerId: record.customerId,
          customerName: record.customerName,
          customerCountry: record.customerCountry,
          customerProvince: record.customerProvince,
          customerCity: record.customerCity,
          customerAddress: record.customerAddress,
          customerPhone: record.customerPhone,
          customerZipcode: record.customerZipcode,
          customerType: record.customerType,
          customerSource: record.customerSource,
          customerEmail: record.customerEmail,
          deliveryRemark: record.deliveryRemark,
          groupJson: record.groupJson,
          remark: record.remark,
          ownerId: record.ownerId,
          ownerName: record.ownerName,
          createAt: record.createAt,
          plateform: record.plateform,
          plateformBargainId: record.plateformBargainId,
          cnyAmount: record.cnyAmount,
          replaceCustomerId: record.replaceCustomerId,
          lastDealtAt: record.lastDealtAt,
          customer: record.customer,
          productAmount: record.productAmount,
          // currentMonthAmount: record.currentMonthAmount,
          plateformStoreId: record.plateformStoreId,
          financeDeliveryAt: record.financeDeliveryAt,
          deliveryAudit: record.deliveryAudit,
          financeAudit: record.financeAudit,
          payAmount: record.payAmount,
          productQty: record.productQty,
          differAmount: record.differAmount,
          ignoreAmount: record.ignoreAmount,
          orders: record.orders,
        };
        rs.push(bOrder); //将bargain的数据转换到格式，放到数据列表
        record.orders.forEach((order) => {
          rs.push(order);
        });
      });
      return rs;
    },
    buildMergeCells(bargains) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < bargains.length; i++) {
        if (this.Permit.canActions("globalSalePrice")) {
          mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 9 });
        } else {
          mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 8 });
        }
        rowIdx = rowIdx + bargains[i].orders.length + 1;
      }
      return mcs;
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isBargain ? "light-blue-bg" : "";
    },

    //=======
    deliver(row, type) {
      const self = this;
      self.row = row;
      self.carryObj.deliverType = type;
      self.carryObj.sender = null;
      self.carryObj.deliverCost = null;
      if (self.carryObj.deliverType === "carry") {
        self.carryObj.sender = self.Permit.currentUser().name;
        self.carrySubmitDoing = false;
        self.carryDF = true;
      } else {
        self.deliverSubmit();
      }
    },
    carrySubmit() {
      const self = this;
      this.$refs.carryForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.carryObj.deliverCost)) {
            self.$message({
              message: self.$t("rules.regex", [
                self.$t("carryObj.deliverCost"),
              ]),
              type: "warning",
            });
            return;
          }
          self.deliverSubmit();
        } else {
          return false;
        }
      });
    },
    deliverSubmit() {
      const self = this;
      self.carrySubmitDoing = true;
      self.deliverDoing = true;
      DeliveryRequisition.deliver(self.row.id, self.carryObj).then(function (
        res
      ) {
        self.carrySubmitDoing = false;
        self.deliverDoing = false;
        self.carryDF = false;
        if (res.status === 200) {
          if (res.data.allQuantity == 0) {
            self.$message({
              message: "不存在发货单项",
              type: "warning",
            });
            return;
          }
          self.sysResults(res.data, self.$t("prompt.deliverSuccess"));
          self.loadData();
          self.$eventHub.$emit("deliveryRequisitionDeliver");
        } else {
          self.sysError();
        }
      });
    },

    // 拒绝
    reject(row) {
      const self = this;
      self.row = row;
      self.rejectObj.comment = null;
      self.rejectDF = true;
    },
    rejectSubmit() {
      const self = this;
      self.rejectDoing = true;
      DeliveryRequisition.reject(self.row.id, self.rejectObj).then(function (
        res
      ) {
        self.rejectDoing = false;
        self.rejectDF = false;
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.rejectSuccess"),
            type: "success",
          });
          self.$eventHub.$emit("deliveryRequisitionReject");
        } else {
          self.sysError();
        }
        self.loadData();
      });
    },
    //
    showRow(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },

    //-----
    dataProvider(params) {
      return DeliveryRequisition.search(params);
    },
  },
};
</script>
